import { LocationMapBox } from '@/features/tickets/components/LocationMapBox';
import type { Position } from '@certhon/models';

/**
 * Shared props for rendering a geotag/location inside a timeline entry.
 * Works with both ticket and checklist events.
 */
export interface TimelineLocationContentProps {
  position: Position;
  label: string;
}

/**
 * Renders an inline map preview for a geotag/location inside a timeline entry.
 */
export function TimelineLocationContent({
  position,
  label,
}: TimelineLocationContentProps) {
  return (
    <div className="mt-2">
      <LocationMapBox position={position} label={label} />
    </div>
  );
}
